import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors } from '@/styles'
import { H4 } from '@/components/text'
import contractImage from './contract_signed.png'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 60px 24px 40px;
`

const Congrats = styled.div`
  display: block;
  margin: 48px 0;
  height: 150px;
  width: 100%;
  background-color: ${colors.white};
  background-image: url('${({ url }) => url}');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
`

const ButtonContainer = styled.div`
  width: 200px;
  > button {
    width: 100%;
  }
`

const CongratulationsModal = () => {
  const { t } = useTranslation()
  const { close } = useModalize()
  return (
    <Wrapper>
      <H4>
        {t('l.contract.view.contract_signing_complete_modal.title', 'Contract Signing Completed!')}
      </H4>
      <Congrats url={contractImage} />
      <ButtonContainer>
        <Button theme="primary" onClick={close}>
          {t('l.contract.view.contract_signing_complete_moda_close.button', 'Ok, Got It!')}
        </Button>
      </ButtonContainer>
    </Wrapper>
  )
}

export const showCongratulationsModal = createModal(CongratulationsModal, {
  width: '460px'
})
